(() => {
  const SELECTOR = 'a[href$="/pages/ring-size-guide"]';
  let dialog;

  function build() {
    dialog = document.createElement('dialog');
    dialog.className = 'size-guide-dialog';
    dialog.setAttribute('aria-label', 'Ring size guide');
    dialog.innerHTML =
      '<button type="button" class="size-guide-dialog__close" aria-label="Close">&times;</button>' +
      '<div class="size-guide-dialog__body"></div>';
    document.body.appendChild(dialog);
    dialog.querySelector('.size-guide-dialog__close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) dialog.close();
    });
    const style = document.createElement('style');
    style.textContent =
      '.size-guide-dialog{border:0;padding:0;max-width:min(640px,92vw);max-height:88vh;width:100%;overflow:auto;background:#fff;color:#111;border-radius:8px;}' +
      '.size-guide-dialog::backdrop{background:rgba(0,0,0,.45);}' +
      '.size-guide-dialog__body{padding:32px 28px 28px;font-size:14px;line-height:1.5;}' +
      '.size-guide-dialog__body h1,.size-guide-dialog__body h2{font-size:1.5rem !important;line-height:1.2 !important;margin:0 0 12px !important;}' +
      '.size-guide-dialog__body h3{font-size:1.25rem !important;line-height:1.2 !important;margin:20px 0 8px;}' +
      '.size-guide-dialog__body table{width:100%;border-collapse:collapse;}' +
      '.size-guide-dialog__body th,.size-guide-dialog__body td{padding:6px 8px;border-bottom:1px solid #e5e5e5;}' +
      '.size-guide-dialog__body th{background:#f2f2f2;white-space:nowrap;}' +
      '.size-guide-dialog__close{position:absolute;top:8px;right:12px;background:none;border:0;font-size:28px;line-height:1;cursor:pointer;color:inherit;}';
    document.head.appendChild(style);
  }

  document.addEventListener('click', async (event) => {
    const link = event.target.closest && event.target.closest(SELECTOR);
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey) return;
    event.preventDefault();
    try {
      const res = await fetch(link.href, { credentials: 'same-origin' });
      if (!res.ok) throw new Error('bad response');
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const content = doc.querySelector('main');
      if (!content) throw new Error('no content');
      if (!dialog) build();
      dialog.querySelector('.size-guide-dialog__body').innerHTML = content.innerHTML;
      dialog.showModal();
    } catch (e) {
      window.location.href = link.href;
    }
  });
})();
